import React from 'react'
import './customer_resources.scss'
import { images } from '../../../utils/customFn'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
const CustomerResources = () => {
  return (
    <>
      <div className='customer-resources'>
        <Row className='gy-5'>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='left-details'>
              <div className='Heading'>
                <h3>Certificate of insurance</h3>
              </div>
              <div className='text'>
                <p>If you’re a Sentry customer, you can download a certificate of insurance through our online portal. Log in to your account to access your certificate.</p>
              </div>
              <Link to="" className='report-btn'>Login {'>'}</Link>
            </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='image-media'>
              <img src={images['man-working-on-laptop.avif']} alt="media" />
            </div>
          </Col>
          <Col sm={12}>
          <div className='borderline'></div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='left-details'>
              <div className='Heading'>
                <h3>Resources</h3>
              </div>
              <div className='text'>
                <p>Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.</p>
              </div>
              <Link to="" className='report-btn'>View resources {'>'}</Link>
            </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div className='image-media'>
              <img src={images['woman-Smiling-Working-on-Laptop.avif']} alt="media" />
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default CustomerResources;